import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const apexeldConfig: TSPConfig = {
  key: 'apexeld',
  name: 'Apex ELD',
  imageName: 'apexeld',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your Apex ELD API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default apexeldConfig;
